module.exports = __webpack_public_path__ + "static/media/user-avatar.65889f60.svg";